const theme = {
    colors:{
        primary : 'rgba(206, 59, 51, 1) !important',
        secondary : ' rgba(170, 170, 170, 1) !important',
        dark: 'rgba(76, 76, 76, 1) !important'
    }
}

export default theme;